
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { PromiserMixin, PromiserType } from 'vuex-modals';
import PersistentModal from '@/components/shared/modals/PersistentModal';
import { Technology } from '@/api/interfaces';
import Autocomplete from '@/components/shared/Autocomplete.vue';
import { repositories } from '@/api/ApiFactory';
import ErrorHandler from '@/components/shared/errorHandler';
import { technologyCreateData } from '@/api/connectivity/technology';
import { ValidationProvider } from 'vee-validate';
@Component({
  components: {
    Autocomplete,
  },
})
export default class AddOrEditTechnologyModal extends Mixins<
  PromiserType,
  PersistentModal
>(PromiserMixin, PersistentModal) {
  @Prop({ default: null }) private data!: Technology | null;
  @Prop() private editMode!: boolean;

  public $refs!: {
    obs: InstanceType<typeof ValidationProvider>;
  };

  private loading = {
    submit: false,
  };

  private technology: technologyCreateData = {
    name: '',
    slug: '',
    doc_url: null,
  };

  created() {
    if (this.editMode && this.data != null) {
      this.technology = {
        name: this.data.name,
        slug: this.data.slug,
        doc_url: this.data.doc_url,
      };
    }
  }

  mounted() {
    if (this.editMode) {
      this.$nextTick(() => {
        this.$refs.obs.validate();
      });
    }
  }

  private async submitUpdate() {
    this.loading.submit = true;
    try {
      const { data } = await repositories.connectivity.technology.update(
        this.data!.slug,
        this.technology,
      );
      this.ok(data);
    } catch (error) {
      this.$toasted.error(new ErrorHandler({ error, status: true }).toString());
    }
    this.loading.submit = false;
  }

  private async submitCreate() {
    this.loading.submit = true;
    try {
      const { data } = await repositories.connectivity.technology.create(
        this.technology,
      );
      this.ok(data);
    } catch (error) {
      this.$toasted.error(new ErrorHandler({ error, status: true }).toString());
    }
    this.loading.submit = false;
  }

  private submit() {
    return this.editMode ? this.submitUpdate() : this.submitCreate();
  }
}
